// src/lawyerSelection/components/ConsultationBox.js
import React, { useState } from "react";
import "./consultationBox.css"; // Ensure this CSS file exists
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import IconCheckbox from "../../../components/input/new/iconCheckbox";

/**
 * @param {Object} consultation - The consultation data
 * @param {boolean} isSelected - Whether this consultation is currently selected
 * @param {function} onSelect - Callback when user selects this consultation
 */
const ConsultationBox = ({ consultation, isSelected, onSelect }) => {
  const [detailsOpen, setDetailsOpen] = useState(false);

  const openDetails = () => {
    setDetailsOpen(true);
  };
  const closeDetails = () => {
    setDetailsOpen(false);
  };

  return (
    <div
      className={`consultation-box ${isSelected ? "selected" : ""}`}
      // Clicking anywhere in the box triggers onSelect (unless we stop propagation).
      aria-checked={isSelected}
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onSelect();
        }
      }}
    >
      <div className="consultation-details">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "15px",
          }}
        >
          <span className="consultation-type-text">
            {consultation.appointment_name}
          </span>
          <IconCheckbox
            checked={isSelected}
            onChange={onSelect}
            onClick={onSelect}
          />
        </div>

        <div style={{ display: "flex" }}>
          <span className="consultation-duration">
            {consultation.appointment_duration} minutes -
          </span>
          <span className="consultation-price">
            {" "}
            ${(consultation.appointment_price / 100).toFixed(2)}
          </span>
        </div>

        <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
          <span className="consultation-description">
            {consultation.appointment_description}
          </span>
          <span
            className="consultation-view-details"
            onClick={() => openDetails()}
          >
            View all Details
          </span>
        </div>
      </div>
      <Dialog open={detailsOpen} onClose={closeDetails} maxWidth="sm" fullWidth>
        <DialogTitle>
          Appointment Details
          <IconButton
            aria-label="close"
            onClick={closeDetails}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent dividers>
          {consultation && (
            <>
              <h6 className="attorney-inbox-detail-label">Appointment Name</h6>
              <p className="attorney-inbox-detail-text">
                {consultation.appointment_name}
              </p>

              <h6 className="attorney-inbox-detail-label">Duration</h6>
              <p className="attorney-inbox-detail-text">
                {consultation.duration || 60} - minutes
              </p>

              <h6 className="attorney-inbox-detail-label">Price</h6>
              <p className="attorney-inbox-detail-text">
                ${(consultation.appointment_price / 100).toFixed(2)}
              </p>

              <h6 className="attorney-inbox-detail-label">Description</h6>
              <p className="attorney-inbox-detail-text">
                {consultation.appointment_description}
              </p>

              <h6 className="attorney-inbox-detail-label">
                Recommended Documents or Required{" "}
                <span className="attorney-inbox-required">*</span>
              </h6>
              <List disablePadding>
                {(consultation.requiredDocuments || []).map((doc, i) => (
                  <ListItem key={i} sx={{ pl: 0 }}>
                    <ListItemText
                      primary={`${i + 1}. ${doc}`}
                      primaryTypographyProps={{ component: "span" }}
                    />
                  </ListItem>
                ))}
              </List>

              <h6 className="attorney-inbox-detail-label">
                Cancellation Policy
              </h6>
              <p className="attorney-inbox-detail-text">
                {consultation.cancellationPolicy ||
                  "Cancellations need to be made at least 24 hours before."}
              </p>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ConsultationBox;
